import { FunctionComponent, useState, useRef, useEffect } from "react"; // Import useState, useRef, useEffect
import CalIcon from "../../assets/task/calendar-icon.svg";
import userCricleimg from "../../assets/task/user-circle_svgrepo.com.svg";
import taskIcons from "../../assets/task/task-square_svgrepo.com.svg";
import userICon from "../../assets/task/uses-icon.svg";
import CalIconcheck from "../../assets/task/task_svgrepo.com.svg";
import { format } from "date-fns";
import triPledots from '../../assets/task/triple_dot.svg'; // Make sure this import is present
import { useNavigate } from "react-router-dom";

interface ClosedTasksProps {
    cg: any;
}

const ClosedTasks: FunctionComponent<ClosedTasksProps> = ({
    cg,
}) => {
    const navigate = useNavigate()
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLImageElement>(null); // Ref for the triple dot button

    const toggleMenu = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent the goal click from being triggered
        setShowMenu(prev => !prev);
    };

    const createdOnDate = cg?.created_on
        ? format(cg?.created_on, 'MMM dd, yyyy') : "";

    const dueDate = cg?.end_datetime
        ? format(cg?.end_datetime, 'MMM dd, yyyy') : ""

    // Close the menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Check if the click is outside the menu AND not on the toggle button
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target as Node) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target as Node)
            ) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // const handleArchive = (e: React.MouseEvent) => {
    //     e.stopPropagation();
    //     console.log(`Archive Goal: ${cg?.id}`);
    //     // onArchiveGoal(cg?.id); // Call a prop function to handle the archive
    //     setShowMenu(false);
    // };

    return (
        <div
            className="self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2 cursor-pointer" // Added cursor-pointer
            onClick={() => {
                navigate("/task_detail", {
                    state: {
                        taskId: cg?.id,
                    }
                })
            }}
        >
            <div className=" parent-dv-item  self-stretch rounded bg-honeydew border-lightseagreen border-solid border-[1px] flex flex-row items-start justify-between p-2 gap-2.5 text-lg relative"> {/* Changed justify-center to justify-between and added relative */}
                <b className=" relative">{cg?.title}</b>
            </div>
            <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                {/* <div className="flex flex-row items-center justify-center gap-1.5">
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                    <div className="relative">Outcome</div>
                </div> */}
                <div className="flex flex-row items-center justify-center text-dimgray">
                    <b className="relative whitespace-pre-wrap">{cg?.static_task_type_name}</b>
                </div>
            </div>
            <hr className="bdr-custom-taskcrad" />
            <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                <div className="flex flex-row items-center justify-center gap-1.5">
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                    <div className="relative">Created Date</div>
                </div>
                <div className="flex flex-row items-center justify-center text-dimgray">
                    <div className="relative whitespace-pre-wrap">{createdOnDate}</div>
                </div>
            </div>
            <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                <div className="flex flex-row items-center justify-center gap-1.5">
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIconcheck} />
                    <div className="relative">Due Date</div>
                </div>
                <div className="flex flex-row items-center justify-center text-dimgray">
                    <div className="relative whitespace-pre-wrap">{dueDate}</div>
                </div>
            </div>
            <hr className="bdr-custom-taskcrad" />
            <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                <div className="flex flex-row items-center justify-center gap-1.5">
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userICon} />
                    <div className="relative">Assignee</div>
                </div>
                <div className="flex flex-row items-center justify-center text-dimgray">
                    <div className="relative">{cg?.assigned_to_name}</div>
                </div>
            </div>
            <hr className="bdr-custom-taskcrad" />
            {/* The progress bar section was commented out in your original code for ClosedGoals, so I've kept it that way. */}
            {/* The original Delayed tag rendering was also commented out, so I'm removing it and mapping all other tags. */}
            {cg?.task_tags?.length > 0 && (
                cg?.task_tags?.map((tag: any) => {
                    return (
                        <div
                            key={tag.id} // Added key for list rendering
                            className="rounded-[100px] bg-crimson flex flex-row items-center justify-center py-1 px-2 text-sm text-white right_status_clockout"
                        >
                            <div className="relative">{tag?.tags_name}</div>
                        </div>
                    );
                })
            )}
        </div>
    );
}

export default ClosedTasks;